import Confirm from "../../../Components/Book Session/confirmation.js";

export default function ConfirmPage(){
    return (
        <Confirm />
    )
}